/**
 * 路由配置
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import { isLoggedIn, handleAuthExpired } from '@/utils/auth'

Vue.use(VueRouter)

// 解决 Vue Router 3.x 导航守卫重定向时的 Promise 报错
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated' && !err.message.includes('Redirected')) {
      return Promise.reject(err)
    }
  })
}
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated' && !err.message.includes('Redirected')) {
      return Promise.reject(err)
    }
  })
}

const routes = [
  {
    path: '/',
    component: () => import('@/components/Layout.vue'),
    redirect: '/home',
    children: [
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/Login.vue'),
        meta: { title: '登录' }
      },
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/views/Home.vue'),
        meta: { title: '首页' }
      },
      {
        path: 'notice',
        name: 'NoticeList',
        component: () => import('@/views/NoticeList.vue'),
        meta: { title: '公告列表' }
      },
      {
        path: 'notice/:id',
        name: 'NoticeDetail',
        component: () => import('@/views/NoticeDetail.vue'),
        meta: { title: '公告详情' }
      },
      {
        path: 'magazine/:id',
        name: 'MagazineDetail',
        component: () => import('@/views/MagazineDetail.vue'),
        meta: { title: '杂志详情' }
      },
      {
        path: 'cart',
        name: 'Cart',
        component: () => import('@/views/Cart.vue'),
        meta: { title: '购物车', requireAuth: true }
      },
      {
        path: 'checkout',
        name: 'Checkout',
        component: () => import('@/views/Checkout.vue'),
        meta: { title: '商品结算', requireAuth: true }
      },
      {
        path: 'payment/bank',
        name: 'BankPayment',
        component: () => import('@/views/payment/BankPayment.vue'),
        meta: { title: '银行汇款', requireAuth: true }
      },
      {
        path: 'payment/wechat',
        name: 'WechatPay',
        component: () => import('@/views/payment/WechatPay.vue'),
        meta: { title: '银联支付', requireAuth: true }
      }
    ]
  },
  {
    path: '/user',
    component: () => import('@/components/UserLayout.vue'),
    meta: { requireAuth: true },
    children: [
      {
        path: 'orders',
        name: 'Orders',
        component: () => import('@/views/user/Orders.vue'),
        meta: { title: '我的订单' }
      },
      {
        path: 'order/:id',
        name: 'OrderDetail',
        component: () => import('@/views/user/OrderDetail.vue'),
        meta: { title: '订单详情' }
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/user/Profile.vue'),
        meta: { title: '个人信息' }
      },
      {
        path: 'invoice',
        name: 'Invoice',
        component: () => import('@/views/user/Invoice.vue'),
        meta: { title: '发票管理' }
      },
      {
        path: 'invoice/:id',
        name: 'InvoiceDetail',
        component: () => import('@/views/user/InvoiceDetail.vue'),
        meta: { title: '发票详情' }
      },
      {
        path: 'address',
        name: 'Address',
        component: () => import('@/views/user/Address.vue'),
        meta: { title: '地址管理' }
      },
      {
        path: 'message',
        name: 'Message',
        component: () => import('@/views/user/Message.vue'),
        meta: { title: '在线客服' }
      },
      {
        path: 'after-sale/:id',
        name: 'AfterSale',
        component: () => import('@/views/user/AfterSale.vue'),
        meta: { title: '申请售后' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  // 路由切换时滚动到顶部
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

// 路由守卫 - 登录验证
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = `${to.meta.title} - 中国人民银行金融研究所杂志在线订阅`
  }
  // 检查是否需要登录
  if (to.matched.some(record => record.meta.requireAuth)) {
    if (!isLoggedIn()) {
      handleAuthExpired('请先登录')
      next(false) // 中止当前导航，由弹窗统一跳转
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
